export const columns = [
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 90,
      scopedSlots: { customRender: 'action' },
      ellipsis: true,
    },{
      title: 'APP编号',
      dataIndex: 'code',
      key: 'code',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'APP名称',
      dataIndex: 'displayName',
      key: 'displayName',
      ellipsis: true,
      width: 100
    },
    {
      title: '版本',
      dataIndex: 'edition',
      key: 'edition',
      width: 100,
      ellipsis: true,
      scopedSlots: { customRender: 'edition' },
    },
    {
      title: '受众',
      dataIndex: 'audience',
      key: 'audience',
      ellipsis: true,
      width: 200,
      scopedSlots: { customRender: 'audience' },
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      ellipsis: true,
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '应用商城',
      dataIndex: 'saleStatus',
      key: 'saleStatus',
      width: 200,
      ellipsis: true,
      scopedSlots: { customRender: 'saleStatus' },
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      ellipsis: true,
      width: 200
    },
  ]
